import "../panoramica.css";
import React from "react";
import { Card, Grid, Popover, Typography } from "@mui/material";
import ViewRowDisponibilita from "./ViewRowDisponibilita";
import { useEffect } from "react";
import { useState } from "react";
import {
  GetAllElelementsWithPrenotazioniCount,
  GetSchedulerPrenotazioni,
} from "../../../const/urlAction";
import axios from "axios";
import handlerError from "../../../functions/handlerError";
import { useDispatch, useSelector } from "react-redux";
import { notificationOpen } from "../../../redux/reducers/notification-reducer";
import PathViewDisponibilita from "./PathViewDisponibilita/PathViewDisponibilita";
import SetActionOnDisponibilita from "../../../functions/disponibilita/setActionOnDisponibilita";
import { Tab, Tabs } from "@mui/material";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { appRoles } from '../../../const/general/roles';


const urlBase = process.env.REACT_APP_URL;

export default function CardViewDisponibilita({
  dateSelected = "",
  timeSelected = "",
  activeBackStepPath,
  handlerStateDialogMappaDisponibilita = () => null,
  returnElementToDialogMostraMappaDisponibilita = () => null,
  isSideEffectCompleted = () => null,
}) {
  const [element, setElement] = useState(null);
  const [elClicked, setElClicked] = useState(undefined);
  const [lengthArrElementPath, setLengthArrElementPath] = useState(0);
  const [isGoodChoice, setisGoodChoice] = useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation(); 
  const [activeTab, setActiveTab] = useState(0);
  const isAdmin = false;
  const state = useSelector((state) => state.userDate);
  const [lastTimeStart, setTimeStart] = useState(null);
  const [lastTimeEnd, setTimeEnd] = useState(null);
  const [lastDate, setDate] = useState(null);
  const [resurces, setResurces] = useState(null);
  const [events, setEvents] = useState(null);
  const [idEdificio, setIdEdificio] = useState(null);
  const [idZona, setIdZona] = useState(null);
  const [isCliccato, setisCliccato] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 600);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [popupTitle, setPopupTitle] = useState(null);
  const [popupText, setPopuoText] = useState(null);
  const [popupTime, setPopupTime] = useState(null);

  const isSubmenuOpen = Boolean(anchorEl);

  useEffect(() => {
    window.addEventListener("resize", handleResizeWindow);
    return () => {
      window.removeEventListener("resize", handleResizeWindow);
    };
  });

  const handleResizeWindow = () => {
    if (window.innerWidth > 600) {
      setIsMobile(false);
    } else {
      setIsMobile(true);
    }
  };

  const handleClick = (eventInfo) => {
    setAnchorEl(eventInfo.jsEvent.target);
    setPopuoText(document.querySelector("[data-resource-id='"+eventInfo?.event?._def?.resourceIds[0] +"']").querySelector(".fc-datagrid-cell-main").textContent)
    setPopupTitle(eventInfo?.event?.title)
    var start = moment(eventInfo?.event._instance.range.start)
    var end = moment(eventInfo?.event._instance.range.end)
    setPopupTime(start.utcOffset(-7200000).format("HH:mm") +"-"+ end.utcOffset(-7200000).format("HH:mm"))
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  //Chiamata per il recupero degli elementi
  useEffect(() => {
    (async () => {
      const { action, method } = GetAllElelementsWithPrenotazioniCount;
      isSideEffectCompleted(false);
      let url = urlBase + action;
      if (timeSelected.length > 0) {
        const body = SetActionOnDisponibilita(
          dateSelected,
          timeSelected,
          elClicked?.subElementType,
          elClicked?.id
        );

        try {
          const response = await axios({
            method: method,
            url,
            data: body,
            headers: {
              "Content-Type": "application/json",
            },
          });
          if (body.IdStanza) {
            returnElementToDialogMostraMappaDisponibilita(response.data.result);
          } else {
            setElement(response.data.result);
            setisGoodChoice(true);
            if (
              lastDate != dateSelected ||
              lastTimeStart != timeSelected[0] ||
              lastTimeEnd != timeSelected[1]
            ) {
              setDate(dateSelected);
              setTimeEnd(timeSelected[1]);
              setTimeStart(timeSelected[0]);
            } else {
              changeTab(null, 0);
            }

            if (elClicked != null || elClicked != undefined) {
              if (elClicked.subElementType === 1) {
                setIdEdificio(elClicked.id);
              }
              if (elClicked.subElementType === 2) {
                setIdZona(elClicked.id);
              }
            }

            if (isCliccato === true && activeTab === 1) {
              GetResultScheduler(
                dateSelected,
                timeSelected,
                idEdificio,
                idZona
              );
            }
          }
        } catch (error) {
          console.error(error);
          const notificationError = handlerError(error);
          dispatch(notificationOpen(notificationError));
          setisGoodChoice(false);
        }
        isSideEffectCompleted(true);
      }
    })();
  }, [elClicked, dateSelected, timeSelected]);

  //chiamata per popolamento dello scheduler
  function GetResultScheduler(dateSelected, timeSelected, idEdificio, idZona) {
    (async () => {
      const { action, method } = GetSchedulerPrenotazioni;
      let url = urlBase + action;
      if (timeSelected.length > 0) {
        const body = {
          GiornoInizio: dateSelected,
          OraInizio: timeSelected[0].toString(),
          OraFine: timeSelected[1].toString(),
          IdEdificio: idEdificio,
          IdZona: idZona,
        };
        try {
          const response = await axios({
            method: method,
            url,
            data: body,
            headers: {
              "Content-Type": "application/json",
            },
          });
          let evetsScheduler = [];
          response.data.result.events.forEach((e) => {
            let arr = [];
            arr.resourceId = e.id;
            arr.title = e.nominativoOspite ?? e.utentePrenotazione;
            arr.start = e.dataInizio.replace("T", " ");
            arr.end = e.dataFine.replace("T", " ");
            if (e.isDisabilitazione === true) {
              arr.title = "Non disponibile";
              arr.backgroundColor = "gray";
              arr.borderColor = "gray";
            } else {
              arr.backgroundColor = "#3e6bb4";
            }
            evetsScheduler.push(arr);
          });
          setEvents(evetsScheduler);
          let resourcesScheduler = [];
          response.data.result.resources.forEach((e) => {
            let arr = [];
            arr.id = e.id;
            arr.stanza = e.stanza;
            arr.title = e.postazione;
            resourcesScheduler.push(arr);
          });
          setResurces(resourcesScheduler);
        } catch (error) {
          console.error(error);
          const notificationError = handlerError(error);
          dispatch(notificationOpen(notificationError));
        }
      }
    })();
  }

  function changeTab(event, value) {
    setActiveTab(value);
    if (value === 1) {
      GetResultScheduler(dateSelected, timeSelected, idEdificio, idZona);
      setisCliccato(true);
    }
  }

  function a11yProps(index) {
    /*props necessarie alle tab */
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  function RenderTab({ isAdmin, state }) {
    let isResponsabile = false;

    if (state?.responsabileEdificio?.length > 0) {
      isResponsabile = state.responsabileEdificio.some(
        (x) => x.idEdificio == idEdificio
      );
    }

    const isUserAdmin = state?.roles?.[0] === appRoles.admin;

    if ((isUserAdmin || isResponsabile) && !isMobile) {
      return (
        <Tabs value={activeTab} onChange={changeTab} centered>
          <Tab
            label={t("overview")}
            {...a11yProps(0)}
            style={{ width: "50%" }}
          />
          <Tab
            label={t("detail")}
            disabled={isMobile}
            {...a11yProps(1)}
            style={{ width: "50%" }}
          />
        </Tabs>
      );
    }
    return null;
  }

  return (
    <>
      {element && (
        <div
          style={{ width: "100%", height: "auto" }}
          className="cardDisponibilita"
        >
          {/* mostra la tab se l'utente è admin */}
          {element.listDeskBookingElement[0].subElementType == 3 && (
            <Grid>
              <RenderTab isAdmin={isAdmin} state={state} />
            </Grid>
          )}
          <PathViewDisponibilita
            el={isGoodChoice ? elClicked : null}
            returnNewPath={setElClicked}
            returnLenghtArrElementPath={setLengthArrElementPath}
            activeBackStepPath={activeBackStepPath}
            handlerStateDialogMappaDisponibilita={
              handlerStateDialogMappaDisponibilita
            }
          />

          {element.listDeskBookingElement.map((ed, index) => {
            return (
              <React.Fragment key={index}>
                {activeTab === 0 && (
                  <ViewRowDisponibilita
                    element={ed}
                    percentStatusConfiguration={
                      element.percentStatusConfiguration
                    }
                    returnIdElementClicked={setElClicked}
                    lengthArrElementPath={lengthArrElementPath}
                  />
                )}
              </React.Fragment>
            );
          })}
        </div>
      )}
      {activeTab === 1 && (
        <Card
          style={{ width: "100%", marginLeft: "10px", marginRight: "10px" }}
        >
          <FullCalendar
            schedulerLicenseKey="GPL-My-Project-Is-Open-Source"
            headerToolbar={{
              left: "  ",
              center: "  ",
              right: "  ",
            }}
            plugins={[
              dayGridPlugin,
              timeGridPlugin,
              interactionPlugin,
              resourceTimelinePlugin,
            ]}
            initialView="resourceTimelineDay"
            resourceOrder={"stanza"}
            resourceGroupField="stanza"
            resourceAreaHeaderContent=" "
            height="500px"
            slotMaxTime={timeSelected[1] + ":00"}
            slotMinTime={timeSelected[0] + ":00"}
            validRange={{
              start: dateSelected,
              end: dateSelected,
            }}
            eventColor={"#3e6bb4"}
            slotLabelFormat={{
              hour: "numeric",
              minute: "2-digit",
              omitZeroMinute: false,
              meridiem: false,
              hour12: false,
            }}
            resources={resurces}
            events={events}
            resourceAreaWidth="15%"
            eventClick={
              (eventInfo) => handleClick(eventInfo)
            }
          />
        </Card>
      )}
          <Popover
           open={isSubmenuOpen}
           anchorEl={anchorEl}
           onClose={handleClose}
           anchorOrigin={{
             vertical: "bottom",
             horizontal: "left"
           }}>
            <Grid container>
              <div style={{padding:"0 0px 0px 0px", width:'15rem'}}>
                <Grid item xs={12} sx={{ backgroundColor: '#3e6bb4', color: '#F9F9FA', paddingLeft:'5px'}}  className="flex-center-left">
                  <Typography className="header-submenu-planimetriaInfo">
                  <b>{popupText}</b>
                  </Typography>
                </Grid>
                <Typography>
                  <Grid container item xs={12} className="containerSubmenu" sx={{ p: 0.5 }}>
                    {popupTitle}
                  </Grid>
                  <Grid container item xs={12} className="containerSubmenu" sx={{ p: 0.5 }}>
                    {popupTime}
                  </Grid>
                </Typography>
            </div> 
          </Grid>
        </Popover> 
    </>
  );
}
